<template>
  <b-container>
    <b-row >
      <b-card
        id="CompanyProfile"
        header="公司简介"
        header-tag="header"
        header-bg-variant="info"
        footer="浏览更多"
        footer-tag="footer"
        footer-text-variant="right"
        title=""
        style="width: 100%;font-size:large;">
        <b-row>
          <b-col cols="4">
            <b-img :src="`${baseUrl}img/1.jpg`" rounded fluid alt="Software"/>
          </b-col>
          <b-col>
            <p class="card-text " style="text-indent:2em;font-size:large;">
              公司自2011年成立以来，主要从事软件研发工作，涉及主要行业：货代、人力资源、医疗系统、电子政务、物流、设备管理等行业软件的研发，可为企业提供行业标准化软件产品，也可以根据企业的自身特点提供量身定制完善的解决方案和软件系统，提高企业和商业生产运行效率，降低企业运营成本。</p>
            <p class="card-text " style="text-indent:2em;font-size:large;">
              公司有着丰厚的技术力量，可提供java、delphi、C++、微服务、浏览器定制、数据库等服务技术。</p>
          </b-col>
        </b-row>

      </b-card>
    </b-row>
    <b-row >
      <b-card
        header="产品介绍"
        header-tag="header"
        header-bg-variant="info"
        footer="浏览更多"
        footer-tag="footer"
        footer-text-variant="right"
        title=""
        style="width: 100%;font-size:large;">
        <p class="card-text" >
          <b-row>
            <b-col cols="6">
              <b-img :src="`${baseUrl}img/freight forwarding.png`" fluid alt="freight forwarding"/>
            </b-col>
            <b-col>
              <span>解决方案提供货运代理与创新，易于使用和非常强大的货代软件，有助于自动化货运代理业务。</span>
              <el-divider/>
              <span>云货代，是管理货运代理的终端到终端业务领域和灵活的货代软件解决方案的方式。</span>
              <el-divider/>
              <span>创新的软件平台，用于货运代理创造无与伦比的商业价值，并帮助企业在竞争中领先一步。</span>
            </b-col>
          </b-row>
          <el-divider/>
          <b-row>
            <b-col cols="6">
              <el-collapse accordion>
                <el-collapse-item>
                  <template slot="title">
                    招聘 Hiring
                  </template>
                  <div>可帮助您每次聘用最优秀的人才。</div>
                </el-collapse-item>
                <el-collapse-item title="入职 Onboarding">
                  <div>全套自动化的登记工具，因此您可以减少对表单的关注，而将更多精力放在创建更好的第一天。</div>
                </el-collapse-item>
                <el-collapse-item title="社保福利 Compensation">
                  <div>简单，自助式的时间跟踪，带薪休假和福利跟踪，使您可以按时准确地向您的员工付款，从而获得轻松愉快的体验。</div>
                </el-collapse-item>
                <el-collapse-item title="文化 Culture">
                  <div>绩效管理的新方法和衡量敬业度的最新工具可帮助您倡导文化并推动组织发展。</div>
                </el-collapse-item>
              </el-collapse>
            </b-col>
            <b-col>
              <b-img :src="`${baseUrl}img/HR.jpg`" fluid alt="freight forwarding"/>
            </b-col>
          </b-row>
          <!-- <b-row>
            <b-col>
              医疗系统
            </b-col>
            <b-col>
              医疗系统
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              OA系统
            </b-col>
            <b-col>
              OA系统
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              企业建站
            </b-col>
            <b-col>
              企业建站
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              电子商务
            </b-col>
            <b-col>
              电子商务
            </b-col>
          </b-row> -->

        </p>
      </b-card>
    </b-row>
    <!-- <b-row >
      <b-card
        header="产品演示"
        header-tag="header"
        header-bg-variant="info"
        footer="浏览更多"
        footer-tag="footer"
        footer-text-variant="right"
        title=""
        style="width: 100%;font-size:large;">
        <p class="card-text">
          <b-list-group flush>
            <b-list-group-item>货代管理</b-list-group-item>
            <b-list-group-item>人力资源</b-list-group-item>
            <b-list-group-item>医疗系统</b-list-group-item>
            <b-list-group-item>OA系统</b-list-group-item>
            <b-list-group-item>企业建站</b-list-group-item>
            <b-list-group-item>电子商务</b-list-group-item>
          </b-list-group>
        </p>
      </b-card>
    </b-row> -->
    <!-- <b-row >
      <b-card
        id="Recruit"
        header="招聘"
        header-tag="header"
        header-bg-variant="info"
        footer="浏览更多"
        footer-tag="footer"
        footer-text-variant="right"
        title=""
        style="width: 100%;font-size:large;">
        <b-row>
          <b-col>
            <b-card
              header="JAVA研发工程师"
              header-tag="header"
              header-bg-variant="Secondary"
              footer=""
              footer-tag="footer"
              footer-text-variant="right"
              title="">
              <p class="card-text">
                技术要求：<br>
                1.大专或以上学历，计算机软件相关专业<br>
                2.JAVA基本扎实，一年以上工作经验<br>
                3.熟悉（spring、SpringMVC、MyBatis、spring boot、spring cloud)框架者优先<br>
                4.熟悉MySql、Sqlserver、Oracle数据库的日常使用<br>
                5.有较强的责任感，肯钻研、主动、合作、敬业<br>
                6.学习能力强，有创造性思维能力和良好的语言表达能力<br>
                7.有HTML5开发经验者优先考虑<br>
                8.熟悉javascript、jquery、bootstrap、angularJS、vue、react的其中一种<br>
                任职要求：<br>
                1.完成软件系统代码的实现，编写代码注释和开发文档<br>
                2.进行系统的功能定义，程序设计<br>
                3.根据设计文档或需求说明完成代码编写，调试，测试和维护<br>
                4.分析并解决软件开发过程中的问题<br>
                5.协助测试工程师制定测试计划，定位发现的问题<br>
                6.完成项目整个过程任务。<br>
                7.可以出差<br>
                福利待遇：<br>
                1.五险一金<br>
                2.年终奖<br>
                3.每年体检<br>
                4.加班调休<br>
                5.带薪年假<br>
                6.每年多次调薪<br>
              </p>
            </b-card>
          </b-col>

          <b-col>
            <b-card
              header="前端设计工程师"
              header-tag="header"
              header-bg-variant="Secondary"
              footer=""
              footer-tag="footer"
              footer-text-variant="right"
              title="">
              <p class="card-text">
                1.熟练使用HTML5、CSS3、JavaScript、jQuery，熟练使用Less或Sass进行前端样式开发，并且对模板化、模块化有一定理解；<br>
                2.了解或熟练使用框架，如AngularJS，React，VUE其中一种；<br>
                3.了解Ant Design Pro框架<br>
                4.能够使用webpack前端构建工具，具备独立搭建及使用webpack等能力<br>
                5.网站页面设计<br>
              </p>
            </b-card>
          </b-col>
        </b-row>
      </b-card>
    </b-row> -->
    <!-- <b-row >
      <b-card
        id="ContactUs"
        header="联系我们"
        header-tag="header"
        header-bg-variant="info"
        footer="浏览更多"
        footer-tag="footer"
        footer-text-variant="right"
        title=""
        style="width: 100%;font-size:large;">
        <p class="card-text" style="text-indent:2em;">
          <b-list-group flush>
            <b-list-group-item>公司地址：烟台市芝罘区西盛街28号第一大道1206-1</b-list-group-item>
            <b-list-group-item>联系电话：15552230109</b-list-group-item>
          </b-list-group>
        </p>
      </b-card>
    </b-row> -->
    <el-tooltip placement="top" content="回到顶部">
      <back-to-top :custom-style="myBackToTopStyle" :visibility-height="300" :back-position="0" transition-name="fade"/>
    </el-tooltip>
  </b-container>

</template>

<script>

import BackToTop from '@/views/elementui/components/BackToTop'

export default {
  name: 'MyMainPage',
  components: { BackToTop },
  data() {
    return {
      baseUrl: process.env.BASE_URL,
      myBackToTopStyle: {
        right: '50px',
        bottom: '50px',
        width: '40px',
        height: '40px',
        'border-radius': '4px',
        'line-height': '45px', // 请保持与高度一致以垂直居中 Please keep consistent with height to center vertically
        background: '#e7eaf1'// 按钮的背景颜色 The background color of the button
      }
    }
  }
}
</script>

<style scoped>
.card {
    margin-bottom: 0.5rem;
}
</style>
